// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_BuscarOrcamentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /orcamentos/buscar_orcamento/{id}
 *
 * Returns a single orcamento with its servicos and cliente.
 *
 * Reuses sibling rows because both /orcamentos/buscar_orcamento and
 * /agenda/buscar_compromisso ultimately call Orcamentos_model::buscar_orcamento(),
 * so the enriched orcamento and orcamento_servicos shapes are identical
 * across both endpoints. Reusing avoids drift.
 *
 * Cliente is endpoint-specific — /orcamentos/buscar_orcamento returns the
 * full clientes-table row via Clientes_model::getCustomerByID(), so it
 * gets its own Row sibling.
 *
 * @see Orcamentos_model::buscar_orcamento()
 * @see Clientes_model::getCustomerByID()
 */
import type { Agenda_BuscarCompromissoOrcamentoDetalhesRow } from './Agenda_BuscarCompromissoOrcamentoDetalhesRow'
import type { Agenda_BuscarCompromissoOrcamentoServicoRow } from './Agenda_BuscarCompromissoOrcamentoServicoRow'
import type { Orcamentos_BuscarOrcamentoClienteRow } from './Orcamentos_BuscarOrcamentoClienteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orcamentos_BuscarOrcamentoResponseDados {
orcamento: Agenda_BuscarCompromissoOrcamentoDetalhesRow | null
servicos: Agenda_BuscarCompromissoOrcamentoServicoRow[] | null
cliente: Orcamentos_BuscarOrcamentoClienteRow | null
}

export type Orcamentos_BuscarOrcamentoResponse = ApiResponse<Orcamentos_BuscarOrcamentoResponseDados>;

registerResponseContract('Orcamentos_BuscarOrcamentoResponse', {
  orcamento: {
    type: 'object',
    required: false,
    fields: {
      orcamento_id:              { type: 'number',  required: true },
      orcamento_franquia_id:     { type: 'number',  required: true },
      orcamento_user_id:         { type: 'string',  required: true },
      orcamento_location_id:     { type: 'number',  required: false },
      orcamento_location_type:   { type: 'string',  required: false },
      orcamento_valor:           { type: 'number',  required: true },
      orcamento_origem:          { type: 'number',  required: false },
      orcamento_data:            { type: 'string',  required: false },
      orcamento_status:          { type: 'string',  required: true },
      orcamento_status_label:    { type: 'string',  required: false },
      orcamento_observacao:      { type: 'string',  required: false },
      orcamento_cliente_id:      { type: 'number',  required: false },
      orcamento_nome_cliente:    { type: 'string',  required: false },
      orcamento_rua:             { type: 'string',  required: false },
      orcamento_cep:             { type: 'string',  required: false },
      orcamento_numero:          { type: 'string',  required: false },
      orcamento_bairro:          { type: 'string',  required: false },
      orcamento_ddi:             { type: 'string',  required: false },
      orcamento_ddd:             { type: 'string',  required: false },
      orcamento_telefone:        { type: 'string',  required: false },
      orcamento_complemento:     { type: 'string',  required: false },
      mostrar_telefone_agenda:   { type: 'boolean', required: false },
      orcamento_franquia_nome:   { type: 'string',  required: false },
      orcamento_localidade_nome: { type: 'string',  required: false },
    },
  },
  servicos: {
    type: 'array',
    required: false,
    items: {
      orcamento_servico_id:            { type: 'number',  required: true },
      orcamento_id:                    { type: 'number',  required: true },
      servico_id:                      { type: 'number',  required: true },
      servico_valor:                   { type: 'number',  required: true },
      orcamento_servico_user_id:       { type: 'string',  required: false },
      orcamento_servico_tipo:          { type: 'number',  required: false },
      orcamento_servico_status:        { type: 'number',  required: true },
      orcamento_servico_qtd:           { type: 'number',  required: true },
      orcamento_servico_data_cadastro: { type: 'string',  required: false },
      servico_nome:                    { type: 'string',  required: true },
    },
  },
  cliente: {
    type: 'object',
    required: false,
    fields: {
      cliente_id:                              { type: 'number',  required: true },
      cliente_nome:                            { type: 'string',  required: true },
      cliente_cpf:                             { type: 'string',  required: true },
      cliente_ddd:                             { type: 'string',  required: false },
      cliente_telefone:                        { type: 'string',  required: false },
      cliente_rua:                             { type: 'string',  required: false },
      cliente_numero:                          { type: 'string',  required: false },
      cliente_complemento:                     { type: 'string',  required: false },
      cliente_bairro:                          { type: 'string',  required: false },
      cliente_cidade_id:                       { type: 'number',  required: false },
      cliente_franquia_id:                     { type: 'number',  required: true },
      cliente_obs:                             { type: 'string',  required: false },
      cliente_location_id:                     { type: 'number',  required: false },
      cliente_location_type:                   { type: 'string',  required: false },
      cliente_link_conversa:                   { type: 'string',  required: false },
      cliente_status:                          { type: 'number',  required: false },
      cliente_data_cadastro:                   { type: 'string',  required: false },
      cliente_origem_id:                       { type: 'number',  required: false },
      cliente_cep:                             { type: 'string',  required: false },
      cliente_ddi:                             { type: 'string',  required: false },
      cliente_data_ultimo_compromisso:         { type: 'string',  required: false },
      cliente_data_ultimo_orcamento:           { type: 'string',  required: false },
      cliente_qtd_compromissos:                { type: 'number',  required: false },
      cliente_data_ultimo_contato_fidelizacao: { type: 'string',  required: false },
      cliente_email:                           { type: 'string',  required: false },
      cliente_data_nascimento:                 { type: 'string',  required: false },
      cliente_genero:                          { type: 'string',  required: false },
      cliente_document_type:                   { type: 'string',  required: false },
      cliente_categoria:                       { type: 'string',  required: false },
      cliente_profissao:                       { type: 'string',  required: false },
    },
  },
})
